import { ShopMetafields } from '~/types'
import DesktopHeader from './DesktopHeader.client'
import MobileHeader from './MobileHeader.client'
import MenuDrawer from './MenuDrawer.client'
import useHeader from './useHeader'

type HeaderProps = {
  storeName: string,
  shop: ShopMetafields,
  desktopHeader?: JSX.Element,
  mobileHeader?: JSX.Element,
  menuDrawer?: JSX.Element
}

export default function Header({ storeName, shop }: HeaderProps) {

  const {
    isCartOpen,
    closeCart,
    setShowCategory,
    goTo,
    openCart,
    showCategory,
    menuItems,
    shopSettings,
    openMenu,
    isMenuOpen,
    closeMenu
  } = useHeader({ shop });

  return (
    <>
      <DesktopHeader
        isCartOpen={isCartOpen}
        closeCart={closeCart}
        setShowCategory={setShowCategory}
        goTo={goTo}
        openCart={openCart}
        showCategory={showCategory}
        menuItems={menuItems}
        shopSettings={shopSettings}
        currency={shop.moneyFormat}
        tagline={shop.tagline}
      />

      <MobileHeader
        openMenu={openMenu}
        openCart={openCart}
      />

      <MenuDrawer
        menuItems={menuItems}
        isOpen={isMenuOpen}
        onClose={closeMenu}
        showCategory={showCategory}
        setShowCategory={setShowCategory}
        goTo={goTo}
        storeName={storeName}
        shopSettings={shopSettings}
      />
    </>
  )
}